const REDIRECT_COUNTER_CGI = 'redirCnt'
const REDIRECT_MAX_COUNT = 5

export const addRedirectCounter = (url: URL) => {
    const redirCnt = parseInt(url.searchParams.get(REDIRECT_COUNTER_CGI) || '0')

    if (redirCnt > REDIRECT_MAX_COUNT) {
        return
    }

    url.searchParams.set(REDIRECT_COUNTER_CGI, (redirCnt + 1).toString())

    return url
}
